import React from "react";
import { IS_THIS_YOU } from "../../mock/mock";
import { Check } from "lucide-react";

export default function IsThisYou() {
  return (
    <section className="bg-[#f3ead9]">
      <div className="max-w-5xl mx-auto px-4 lg:px-8 py-16 md:py-24">
        <div className="text-center">
          <p className="eyebrow text-lg">{IS_THIS_YOU.eyebrow}</p>
          <div className="mx-auto mt-3 ornament-line" />
          <h2 className="mt-4 font-serif-display text-3xl md:text-5xl leading-tight text-[#1a1a1a] max-w-3xl mx-auto">
            {IS_THIS_YOU.heading}
          </h2>
        </div>

        <ul className="mt-10 grid md:grid-cols-2 gap-4">
          {IS_THIS_YOU.items.map((it) => (
            <li key={it} className="flex items-start gap-3 bg-white/70 border border-[#e2d5bb] rounded-xl px-5 py-4">
              <span className="mt-1 h-6 w-6 rounded-full bg-[#7a1e2f] text-white grid place-items-center shrink-0"><Check size={14} /></span>
              <span className="text-[15px] text-[#1a1a1a]/85">{it}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
